module.exports = __webpack_public_path__ + "img/more-vertical.8d436fab.svg";